import React, { useState, useEffect, useRef } from 'react';
import { Icon } from '@fluentui/react/lib/Icon';
import dompurify from 'dompurify';
import { v4 as uniqueIdGenerator } from 'uuid';
import Dropdown from '../Dropdown';
import $ from 'jquery';
import { toast } from 'react-toastify';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const ExitCriteriaContribution = ({
	contributorsData,
	exitCriteriaButtonClicked,
	setExitCriteriaButtonClicked,
	outputButtonClicked,
	setOutputButtonClicked,
	ckEditorUserMap,
	CkEditorCurrentUser,
	exitCriteriaSuggestions,
	setExitCriteriaSuggestions,
	exitCriteriaWithSuggestions,
	setExitCriteriaWithSuggestions,
	outputSuggestions,
	setOutputSuggestions,
	reviewedExitCriteriaSuggestions,
	setReviewedExitCriteriaSuggestions,
	reviewerExitCriteriaSuggestions,
	source,
	exitCriteriaData,
	setExitCriteriaData,
	currentTab,
	setCurrentTab,
	exitContributionReorder,
	outputContributionReorder,
	setExitContributionReorder,
	setOutputContributionReorder,
	setExitCriteriaReorderArray,
	exitCriteriaReorderArray,
	setOutputCriteriaReorderArray,
	outputCriteriaReorderArray,
	reviewedReorderedExitSuggestions,
	setReviewedReorderedExitSuggestions,
	reviewedReorderedOutputSuggestions,
	setReviewedReorderedOutputSuggestions,
	initialExitIdBeforeReorder,
    setInitialExitIdBeforeReorder,
	ckEditorCurrentExitReorderUsername,
    setCkEditorCurrentExitReorderUsername,
    ckEditorCurrentExitReorderUserImage,
    setCkEditorCurrentExitReorderUserImage,
	ckEditorCurrentOutputReorderUserImage,
	setCkEditorCurrentOutputReorderUserImage,
	ckEditorCurrentOutputReorderUsername,
	setCkEditorCurrentOutputReorderUsername,
	disableExitDrag,
	setDisableExitDrag,
	disableOutputDrag,
	setDisableOutputDrag,
	user,
	setIsReviewerExitReordered,
	setIsReviewerOutputReordered,
	setIsApproverExitReordered,
    setIsApproverOutputReordered,
	setReorderContributionCount,
	setAddedExitSequence,
	setIsOrderChanged,
	pageTypeCalling,
	disableControls
}) => {
	const pageType = ['review', 'approve'];
	const htmlSanitizer = dompurify.sanitize;
	const defaultCriteriType = {
		id: 1,
		name: 'Text',
	};
	const defaultCriteriaTypeValue = {
		2: 'Numeric',
		1: 'Text',
	};
	const dropdownValue = [
		{ id: 1, name: 'Text', type: 'option' },
		{ id: 2, name: 'Numeric', type: 'option' },
	];
	const inputRefs = useRef({});
	const [currentExitTab, setCurrentExitTab] = useState('tab-exit');
	const [isHideInputBox, setIsHideInputBox] = useState(true);
	const [dropdownValues, setDropdownValues] = useState({});
	const [newItemDescription, setNewItemDescription] = useState("")
	const [criteriaName, setCriteriaName] = useState('');
	const [criteriaDescription, setCriteriaDescription] = useState('');
	const [criteriaType, setCriteriaType] = useState(defaultCriteriType);
	const [error, setError] = useState(false);
	const [editMode, setEditMode] = useState(false);
	const [updateId, setUpdateId] = useState(0);
	const [outputEditMode, setOutputEditMode] = useState(false);
	const [outputUpdateId, setOutputUpdateId] = useState(0);
	const [exitCriteriaList, setExitCriteriaList] = useState([
		...contributorsData.exitCriteriaList.filter(
			(item) => item.criteriaTypeName === 'Exit Criteria'
		),
	]);
	const [outputList, setOutputList] = useState([
		...contributorsData.exitCriteriaList.filter(
			(item) => item.criteriaTypeName !== 'Exit Criteria'
		),
	]);
	const [outputDescription, setOutputDescription] = useState('');
	const [toolsSidebarHeight, setToolsSidebarHeight] = useState('50px');
	const [sidebarCard, setSidebarCard] = useState([]);
	const [userImgWithReorder, setUserImgWithReorder] = useState(null)
	const [userNameWithReorder, setUserNameWithReorder] = useState(null)
	const [exitListwithInsert,  setExitListwithInsert] = useState([...contributorsData.exitCriteriaList.filter(
		(item) => item.criteriaTypeName === 'Exit Criteria'
	       ),])
	const [outputListwithInsert,  setOutputListwithInsert] = useState([...contributorsData.exitCriteriaList.filter(
		(item) => item.criteriaTypeName === 'Output'
	      ),
	      ]);
	const [initialExitCriteriaBeforeReorder, setInitialExitCriteriaBeforeReorder]=useState([...initialExitIdBeforeReorder.filter(
			(item)=> JSON.parse(item).criteriaTypeName === 'Exit Criteria'
		  )])
	const [initialOutputCriteriaBeforeReorder, setInitialOutputCriteriaBeforeReorder] = useState([...initialExitIdBeforeReorder.filter(
			(item)=> JSON.parse(item).criteriaTypeName === 'Output')])



	

	const removeSuggestion = (value) => {
		const filteredValue = exitCriteriaSuggestions.filter(
			(item) => JSON.parse(item).id !== JSON.parse(value).id
		);
		setExitCriteriaSuggestions([...filteredValue]);
		if (
			pageType.includes(source) &&
			JSON.parse(value).authorId !== CkEditorCurrentUser
		) {
			setReviewedExitCriteriaSuggestions([
				...reviewedExitCriteriaSuggestions,
				JSON.stringify({ id: JSON.parse(value).id, state: 'rejected' }),
			]);
			const criteriaType = JSON.parse(value).criteriaTypeName;
			if(exitContributionReorder && ckEditorCurrentExitReorderUsername !== user.profile.firstName + ' '+user.profile.surname 
			   && criteriaType === 'Exit Criteria'&& JSON.parse(value).suggestionType==='insertion'){
				const initialExit = initialExitCriteriaBeforeReorder.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
				const filteredExit = exitCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName === 'Exit Criteria')
				const currentExit = filteredExit.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
				const isSimilar = initialExit.some((element, index) => element !== currentExit[index])
				if(!isSimilar){
				  removeReorderedSuggestions('exit');
				  toast.info('Reorder suggestion has rejected automatically', {
					position: toast.POSITION.TOP_RIGHT,
				  });
				}
			  }
			 
		}
		if (
			source === 'approve'
			&& JSON.parse(value).authorId === CkEditorCurrentUser
			&& reviewerExitCriteriaSuggestions?.some((item) => JSON.parse(item).id === JSON.parse(value).id)
		) {
			setReviewedExitCriteriaSuggestions([
				...reviewedExitCriteriaSuggestions,
				JSON.stringify({ id: JSON.parse(value).id, state: 'rejected' }),
			]);
		}
		if (exitCriteriaList.some((item) => item.id === JSON.parse(value).id)) {
			const updatedList = exitCriteriaWithSuggestions.map((item) =>
				JSON.parse(item).id === JSON.parse(value).id
					? JSON.stringify({
						...exitCriteriaList.filter(
							(item) => JSON.parse(value).id === item.id
						)[0],
						suggestionType: 'none',
						suggestionId: null,
						authorId: CkEditorCurrentUser,
						createdAt: new Date(),
					})
					: item
			);

			setExitCriteriaWithSuggestions([...updatedList]);
			setInitialExitIdBeforeReorder(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))

		} else {
			const filteredList = exitCriteriaWithSuggestions.filter(
				(item) => JSON.parse(item).id !== JSON.parse(value).id
			);
			const initialExitFilteredList = initialExitCriteriaBeforeReorder.filter(
				(item) => JSON.parse(item).id !== JSON.parse(value).id
			);
			setExitCriteriaWithSuggestions([...filteredList]);
			setInitialExitCriteriaBeforeReorder(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
            setExitListwithInsert([...initialExitFilteredList.map(e=>JSON.parse(e))])
            setExitCriteriaReorderArray(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
		}
	};

	const acceptSuggestion = (value) => {
		//setExitCriteriaList([...exitCriteriaList, JSON.parse(item)]);
		if (JSON.parse(value).suggestionType === 'deletion') {
			const criteriaType = JSON.parse(value).criteriaTypeName;
			if(exitContributionReorder && ckEditorCurrentExitReorderUsername !== user.profile.firstName + ' '+user.profile.surname 
			   && criteriaType === 'Exit Criteria'){
				const initialExit = initialExitCriteriaBeforeReorder.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
				const filteredExit = exitCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName === 'Exit Criteria')
				const currentExit = filteredExit.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
				const isSimilar = initialExit.some((element, index) => element !== currentExit[index])
				if(!isSimilar){
				  removeReorderedSuggestions('exit');
				  toast.info('Reorder suggestion has rejected automatically', {
					position: toast.POSITION.TOP_RIGHT,
				  });
				}
			  }
			if (exitCriteriaList.some((item) => item.id === JSON.parse(value).id)) {
				const updatedExitCriteria = exitCriteriaList.filter(
					(item) => item.id !== JSON.parse(value).id
				);
				setExitCriteriaList([...updatedExitCriteria]);
				const updatedDataList = exitCriteriaData.filter(
					(item) => item.id !== JSON.parse(value).id
				);
				setExitCriteriaData([...updatedDataList]);
				const filteredList = exitCriteriaWithSuggestions.filter(
					(item) => JSON.parse(item).id !== JSON.parse(value).id
				);
				setExitCriteriaWithSuggestions([...filteredList]);
				setInitialExitCriteriaBeforeReorder(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
				if(exitCriteriaReorderArray !== null){
				  setExitCriteriaReorderArray(prev=>prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
				}
			} else {
				const filteredList = exitCriteriaWithSuggestions.filter(
					(item) => JSON.parse(item).id !== JSON.parse(value).id
				);
				setExitCriteriaWithSuggestions([...filteredList]);
			}
		} else {
			const updatedList = exitCriteriaWithSuggestions.map((item) =>
				JSON.parse(item).id === JSON.parse(value).id
					? JSON.stringify({
						...JSON.parse(item),
						suggestionType: 'none',
						suggestionId: null,
						authorId: CkEditorCurrentUser,
						createdAt: new Date(),
					})
					: item
			);
			setExitCriteriaWithSuggestions([...updatedList]);
			if (!exitCriteriaList.some((item) => item.id === JSON.parse(value).id)) {
				const criteria = {
					id: JSON.parse(value).id,
					name: JSON.parse(value).name,
					criteriaType: JSON.parse(value).criteriaType,
					valueType: JSON.parse(value).valueType,
					createdDate: JSON.parse(value).createdDate,
					createdBy: JSON.parse(value).authorId,
					criteriaTypeID: JSON.parse(value).criteriaTypeID,
					criteriaTypeName: JSON.parse(value).criteriaTypeName,
				};
				let increment = 1;
                const updatedExitData = ([...exitCriteriaData, criteria])
				updatedExitData.forEach((e,i)=>{
					if(e.criteriaTypeID === 2){
						e.sequence = increment;
						increment ++
					} 
				})
				setExitCriteriaData(updatedExitData);
				setExitCriteriaList([...exitCriteriaList, criteria]);
			} else {
				const updatedList = exitCriteriaList.map((item) =>
					item.id === JSON.parse(value).id ? JSON.parse(value) : item
				);
				setExitCriteriaList([...updatedList]);
				const updatedData = exitCriteriaData.map((item) =>
					item.id === JSON.parse(value).id ? JSON.parse(value) : item
				);
				setExitCriteriaData([...updatedData]);
			}
		}

		const filteredValue = exitCriteriaSuggestions.filter(
			(item) => JSON.parse(item).id !== JSON.parse(value).id
		);
		setExitCriteriaSuggestions([...filteredValue]);
		setReviewedExitCriteriaSuggestions([
			...reviewedExitCriteriaSuggestions,
			JSON.stringify({ id: JSON.parse(value).id, state: 'accepted' }),
		]);
	};

	const removeOutputSuggestion = (value) => {
		const filteredValue = exitCriteriaSuggestions.filter(
			(item) => JSON.parse(item).id !== JSON.parse(value).id
		);
		setExitCriteriaSuggestions([...filteredValue]);
		if (
			pageType.includes(source) &&
			JSON.parse(value).authorId !== CkEditorCurrentUser
		) {
			setReviewedExitCriteriaSuggestions([
				...reviewedExitCriteriaSuggestions,
				JSON.stringify({ id: JSON.parse(value).id, state: 'rejected' }),
			]);
			const criteriaType = JSON.parse(value).criteriaTypeName;
			if(outputContributionReorder && ckEditorCurrentOutputReorderUsername !== user.profile.firstName + ' '+user.profile.surname 
			&& criteriaType === 'Output'&& JSON.parse(value).suggestionType==='insertion'){
		   const initialOutput = initialOutputCriteriaBeforeReorder.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
		   const filteredOutput = exitCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName === 'Output')
		   const currentOutput = filteredOutput.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
		   const isSimilar = initialOutput.some((element, index) => element !== currentOutput[index])
		   if(!isSimilar){
			 removeReorderedSuggestions('output');
			 toast.info('Reorder suggestion has rejected automatically', {
				position: toast.POSITION.TOP_RIGHT,
			  });
		   }
		 }
		}
		if (
			source === 'approve'
			&& JSON.parse(value).authorId === CkEditorCurrentUser
			&& reviewerExitCriteriaSuggestions?.some((item) => JSON.parse(item).id === JSON.parse(value).id)
		) {
			setReviewedExitCriteriaSuggestions([
				...reviewedExitCriteriaSuggestions,
				JSON.stringify({ id: JSON.parse(value).id, state: 'rejected' }),
			]);
		}
		if (outputList.some((item) => item.id === JSON.parse(value).id)) {
			const updatedList = exitCriteriaWithSuggestions.map((item) =>
				JSON.parse(item).id === JSON.parse(value).id
					? JSON.stringify({
						...outputList.filter(
							(item) => JSON.parse(value).id === item.id
						)[0],
						suggestionType: 'none',
						suggestionId: null,
						authorId: CkEditorCurrentUser,
						createdAt: new Date(),
					})
					: item
			);

			setExitCriteriaWithSuggestions([...updatedList]);
		} else {
			const filteredList = exitCriteriaWithSuggestions.filter(
				(item) => JSON.parse(item).id !== JSON.parse(value).id
			);
			const initialOutpuFilteredList = initialOutputCriteriaBeforeReorder.filter(
				(item) => JSON.parse(item).id !== JSON.parse(value).id
			);
			setExitCriteriaWithSuggestions([...filteredList]);
			setInitialOutputCriteriaBeforeReorder(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
			setOutputListwithInsert([...initialOutpuFilteredList.map(e=>JSON.parse(e))])
			setOutputCriteriaReorderArray(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
		}
	};

	const acceptOutputSuggestion = (value) => {
		if (JSON.parse(value).suggestionType === 'deletion') {
			const criteriaType = JSON.parse(value).criteriaTypeName;
			if(outputContributionReorder && ckEditorCurrentOutputReorderUsername !== user.profile.firstName + ' '+user.profile.surname 
			&& criteriaType === 'Output'){
		   const initialOutput = initialOutputCriteriaBeforeReorder.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
		   const filteredOutput = exitCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName === 'Output')
		   const currentOutput = filteredOutput.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
		   const isSimilar = initialOutput.some((element, index) => element !== currentOutput[index])
		   if(!isSimilar){
			 removeReorderedSuggestions('output');
			 toast.info('Reorder suggestion has rejected automatically', {
				position: toast.POSITION.TOP_RIGHT,
			  });
		   }
		 }
			if (outputList.some((item) => item.id === JSON.parse(value).id)) {
				const updatedExitCriteria = outputList.filter(
					(item) => item.id !== JSON.parse(value).id
				);
				setOutputList([...updatedExitCriteria]);
				const updatedDataList = exitCriteriaData.filter(
					(item) => item.id !== JSON.parse(value).id
				);
				setExitCriteriaData([...updatedDataList]);
				const filteredList = exitCriteriaWithSuggestions.filter(
					(item) => JSON.parse(item).id !== JSON.parse(value).id
				);
				setExitCriteriaWithSuggestions([...filteredList]);
				setInitialOutputCriteriaBeforeReorder(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
                if(outputCriteriaReorderArray !== null){
                setOutputCriteriaReorderArray(prev=>prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
				}
			} else {
				const filteredList = exitCriteriaWithSuggestions.filter(
					(item) => JSON.parse(item).id !== JSON.parse(value).id
				);
				setExitCriteriaWithSuggestions([...filteredList]);
			}
		} else {
			const updatedList = exitCriteriaWithSuggestions.map((item) =>
				JSON.parse(item).id === JSON.parse(value).id
					? JSON.stringify({
						...JSON.parse(item),
						suggestionType: 'none',
						suggestionId: null,
						authorId: CkEditorCurrentUser,
						createdAt: new Date(),
					})
					: item
			);
			setExitCriteriaWithSuggestions([...updatedList]);
			if (!outputList.some((item) => item.id === JSON.parse(value).id)) {
				const criteria = {
					id: JSON.parse(value).id,
					name: JSON.parse(value).name,
					criteriaType: JSON.parse(value).criteriaType,
					valueType: JSON.parse(value).valueType,
					createdDate: JSON.parse(value).createdDate,
					createdBy: JSON.parse(value).authorId,
					criteriaTypeID: JSON.parse(value).criteriaTypeID,
					criteriaTypeName: JSON.parse(value).criteriaTypeName,
				};
				let increment = 1;
                const updatedOutputData = ([...exitCriteriaData, criteria])
				updatedOutputData.forEach((e,i)=>{
					if(e.criteriaTypeID === 4){
						e.sequence = increment;
						increment ++
					} 
				})
				setExitCriteriaData(updatedOutputData);
				setOutputList([...outputList, criteria]);
			} else {
				const updatedList = outputList.map((item) =>
					item.id === JSON.parse(value).id ? JSON.parse(value) : item
				);
				setOutputList([...updatedList]);
				const updatedData = exitCriteriaData.map((item) =>
					item.id === JSON.parse(value).id ? JSON.parse(value) : item
				);
				setExitCriteriaData([...updatedData]);
			}
		}

		const filteredValue = exitCriteriaSuggestions.filter(
			(item) => JSON.parse(item).id !== JSON.parse(value).id
		);
		setExitCriteriaSuggestions([...filteredValue]);
		setReviewedExitCriteriaSuggestions([
			...reviewedExitCriteriaSuggestions,
			JSON.stringify({ id: JSON.parse(value).id, state: 'accepted' }),
		]);
	};

	const handleCriteriaDescription = (event) => {
		setCriteriaDescription(event.target.value);
	};

	const handleOutputDescription = (event) => {
		setOutputDescription(event.target.value);
	};

	$(document).ready(function () {
		// $('ul.exit-criteria-tabs li').click(function () {
		// 	var tab_id = $(this).attr('data-tab');
		// 	setCurrentExitTab(tab_id);
		// 	$('ul.exit-criteria-tabs li').removeClass('currentExit');
		// 	$('.exit-criteria-tab-content').removeClass('currentExit');

		// 	$(this).addClass('currentExit');
		// 	$('#' + tab_id).addClass('currentExit');
		// });
	});
	const removeReorderedSuggestions = (field) => {
		const parsedTasks = exitCriteriaWithSuggestions.map((item) => {
			return JSON.parse(item)
		})
		if (field === 'exit') {
			const filteredExitParsed = parsedTasks.filter((item) => {
				return item.criteriaTypeName === "Exit Criteria"
			})
			//Creating this for Concatination. Parse Not required
	        const  filteredOutputParsed = exitCriteriaWithSuggestions.filter((item) => {
				return JSON.parse(item).criteriaTypeName === "Output"
			})
			const parsedInitialExitCriteriaBeforeReorder =initialExitCriteriaBeforeReorder.map(e=>JSON.parse(e))
			const parsedArray = filteredExitParsed.map((item) => {
				return JSON.stringify({
					...item,
					sequence: parsedInitialExitCriteriaBeforeReorder.filter((v) => v.id === item.id)[0].sequence,
					authorId: item.authorId !== CkEditorCurrentUser ? item.authorId :CkEditorCurrentUser,
					createdAt: new Date(),
				})
			})
			const beforeSortingArray = parsedArray.map((item) => {
				return JSON.parse(item)
			})
			beforeSortingArray.sort((a, b) => a.sequence - b.sequence)
			const afterSortAndStringify = beforeSortingArray.map((item) => {
				return JSON.stringify(item)
			})
			setExitCriteriaWithSuggestions([...afterSortAndStringify.concat(filteredOutputParsed)]);
			setExitContributionReorder(false)
			setExitCriteriaReorderArray([])
			if(source === 'review'){
				setIsReviewerExitReordered(false)
			}
			if(source === 'approve'){
				setIsApproverExitReordered(false)
			}
			if (
				pageType.includes(source)  && ckEditorCurrentExitReorderUsername !== user.profile.firstName + ' '+user.profile.surname
				
			  ) {
				setReviewedReorderedExitSuggestions([JSON.stringify({ id: uniqueIdGenerator(), state: 'rejected',name:'Exit' })])
				setReorderContributionCount((prev)=> prev - 1)
			}
			setDisableExitDrag(false)
		}
		else {
			const filteredOutputParsed = parsedTasks.filter((item) => {
				return item.criteriaTypeName === "Output"
			})
			//Creating this for Concatination. Parse Not required

			const  filteredExitParsed = exitCriteriaWithSuggestions.filter((item) => {
				return JSON.parse(item).criteriaTypeName === "Exit Criteria"
			})
			const parsedInitialOutputCriteriaBeforeReorder = initialOutputCriteriaBeforeReorder.map(e=>JSON.parse(e))
			const parsedArray = filteredOutputParsed.map((item) => {
				return JSON.stringify({
					...item,
					sequence: parsedInitialOutputCriteriaBeforeReorder.filter((v) => v.id === item.id)[0].sequence,
					authorId: item.authorId !== CkEditorCurrentUser ? item.authorId :CkEditorCurrentUser,
					createdAt: new Date(),
				})
			})
			const beforeSortingArray = parsedArray.map((item) => {
				return JSON.parse(item)
			})
			beforeSortingArray.sort((a, b) => a.sequence - b.sequence)
			const afterSortAndStringify = beforeSortingArray.map((item) => {
				return JSON.stringify(item)
			})
			setExitCriteriaWithSuggestions([...filteredExitParsed.concat(afterSortAndStringify)]);
			setOutputContributionReorder(false)
			setOutputCriteriaReorderArray([])
			if(source === 'review'){
				setIsReviewerOutputReordered(false)
			}
			if(source === 'approve'){
				setIsApproverOutputReordered(false)
			}
			if (
				pageType.includes(source)  && ckEditorCurrentOutputReorderUsername !== user.profile.firstName + ' '+user.profile.surname
			  ) {
				setReviewedReorderedOutputSuggestions([JSON.stringify({ id: uniqueIdGenerator(), state: 'rejected',name:'Output' })])
				setReorderContributionCount((prev)=> prev - 1)
			}
			setDisableOutputDrag(false)
		}

	}

	useEffect(()=>{
		const currentExitCriteria = exitCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName
		=== 'Exit Criteria').map(e=>JSON.parse(e).id)

		const currentOutputCriteria = exitCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName
		=== 'Output').map(e=>JSON.parse(e).id)
		const arraysAreEqual =(arr1, arr2) => {
			if(!arr1 && !arr2){
				return false
			}
			const initial = arr1.map((e) => JSON.parse(e).id);
			if (arr1.length !== initial.length) {
			  return false;
			}
		  return initial.some((element, index) => element !== arr2[index]);
		  }
		  
        const exitHasChanged = arraysAreEqual(initialExitCriteriaBeforeReorder, currentExitCriteria)
		
		const outputHasChanged = arraysAreEqual(initialOutputCriteriaBeforeReorder, currentOutputCriteria)
	
		setExitContributionReorder(exitHasChanged)
		setIsOrderChanged(prevState => ({
			...prevState,
			exit: exitHasChanged 
		  }))
		setOutputContributionReorder(outputHasChanged)
		setIsOrderChanged(prevState => ({
			...prevState,
			output: outputHasChanged 
		  }))
	},[exitCriteriaWithSuggestions])

	const acceptExitReorderSuggestion=()=>{
		const isNotCurrentUser = exitCriteriaSuggestions.some(e=>JSON.parse(e).authorId !== CkEditorCurrentUser )
		
			if(exitCriteriaSuggestions && exitCriteriaSuggestions.length !==0 && isNotCurrentUser){
        toast.error('Please accept or reject other Exit/Output suggestions before accepting reorder', {
        position: toast.POSITION.TOP_RIGHT,
      })
	 }  else {
		setReviewedReorderedExitSuggestions([JSON.stringify({ id: uniqueIdGenerator(), state: 'accepted',name:'Exit' })])
		setExitContributionReorder(false);
		const currentExitCriteria = exitCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName
		=== 'Exit Criteria')

		setInitialExitCriteriaBeforeReorder(currentExitCriteria)
		setReorderContributionCount((prev)=> prev - 1)
	   }
	}
	
	   const acceptOutputReorderSuggestion=()=>{
		const isNotCurrentUser = exitCriteriaSuggestions.some(e=>JSON.parse(e).authorId !== CkEditorCurrentUser )
		if(exitCriteriaSuggestions && exitCriteriaSuggestions.length !==0 && isNotCurrentUser){
        toast.error('Please accept or reject other Exit/Output suggestions before accepting reorder', {
        position: toast.POSITION.TOP_RIGHT,
      })
	 }  else {
		setReviewedReorderedOutputSuggestions([JSON.stringify({ id: uniqueIdGenerator(), state: 'accepted',name:'Output' })])
		setOutputContributionReorder(false);
		const currentOutputCriteria = exitCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName
		=== 'Output')

		setInitialOutputCriteriaBeforeReorder(currentOutputCriteria)
		setReorderContributionCount((prev)=> prev - 1)
	   }
	}


	const renderSuggestions = () => {
		return (
			<div
				className={`toolsSidebar ${currentExitTab === 'tab-exit' ? '' : 'hiddenExitCriteria'
					} `}
				style={{ minHeight: toolsSidebarHeight, maxHeight:'300px' }}
			>    
			{
					exitContributionReorder && <>
						<div className='sideBarCard userAddedItem'>
							<div className="sideBarCardHeader">
								<img
									className="userImg"
									src={ckEditorCurrentExitReorderUserImage}
									alt=""
								/>
								<span>{ckEditorCurrentExitReorderUsername}</span>
								<Icon
									title="Reject Suggestion"
									ariaLabel={`Click to reject the Reorder`}
									role="button"
									iconName="Cancel"
									onClick={() => removeReorderedSuggestions('exit')}
									onKeyPress={(e) => {
										if (e.which === 13) {
											removeReorderedSuggestions('exit');
										}
									}}
									tabIndex={0}
								/>
								  {pageType.includes(source) && 
								  ckEditorCurrentExitReorderUsername !== user.profile.firstName + ' '+user.profile.surname &&
                               (
                               <Icon
                        title="Accept Suggestion"
                        iconName="Accept"
                        onClick={() => acceptExitReorderSuggestion()}
                        onKeyPress={(e) => {
                          if (e.which === 13) {
                            acceptExitReorderSuggestion();
                          }
                        }}
                        ariaLabel={'click to accept as suggestion'}
                        role="button"
                        tabIndex={0}
                      />
                    
                    )}
								<div className="itemStatus">
									<span>
										Reordered
									</span>
									&nbsp;"Description: Exit Criteria has been Reordered"
								</div>

							</div>
						</div>
					</>
				}
				
				{exitCriteriaSuggestions &&
					exitCriteriaWithSuggestions.map((card) => (
						<>
							{JSON.parse(card).criteriaTypeName === 'Exit Criteria' &&
								(JSON.parse(card).suggestionType === 'none' ? (
									<></>
								) : (
									<div
										className={`sideBarCard ${JSON.parse(card).suggestionType === 'deletion'
											? 'userDeletedToolsAndGuidance'
											: 'userAddedItem'
											}`}
									>
										<div className="sideBarCardHeader">
											<img
												className="userImg"
												src={ckEditorUserMap[JSON.parse(card).authorId][1]}
												alt=""
											/>
											<span className="nonCkEditorAuthor">
												{ckEditorUserMap[JSON.parse(card).authorId][0]}
											</span>

											{JSON.parse(card).authorId === CkEditorCurrentUser ||
												(pageType.includes(source) &&
													JSON.parse(card).authorId !== CkEditorCurrentUser) ? (
												<Icon
													title="Reject Suggestion"
													ariaLabel={`Click to reject ${JSON.parse(card).name
														} as suggestion`}
													role="button"
													iconName="Cancel"
													onClick={() => removeSuggestion(card)}
													onKeyPress={(e) => {
														if (e.which === 13) {
															removeSuggestion(card);
														}
													}}
													// onClick={() => removeTemplate(JSON.parse(card))}
													// onKeyPress={(e) => {
													// 	if (e.which === 13) {
													// 		removeTemplate(JSON.parse(card));
													// 	}
													// }}
													tabIndex={0}
												/>
											) : (
												<></>
											)}
											{pageType.includes(source) &&
												JSON.parse(card).authorId !== CkEditorCurrentUser ? (
												<Icon
													title="Accept Suggestion"
													iconName="Accept"
													onClick={() => acceptSuggestion(card)}
													onKeyPress={(e) => {
														if (e.which === 13) {
															acceptSuggestion(card);
														}
													}}
													ariaLabel={`Click to Accept ${JSON.parse(card).name
														} as suggestion`}
													role="button"
													tabIndex={0}
												/>
											) : (
												<></>
											)}
										</div>
										<div className="itemStatus">
											<span>
												{JSON.parse(card).suggestionType === 'insertion'
													? 'Add'
													: JSON.parse(card).suggestionType === 'deletion'
														? 'Remove'
														: 'Edit'}
											</span>
											&nbsp;"Text/Numeric:
											{JSON.parse(card).valueType === 1
												? 'Text'
												: 'Numeric'}{' '}
											Description:{JSON.parse(card).name}"
										</div>
									</div>
								))}
						</>
					))}
			</div>
		);
	};
   
	const renderOutputSuggestions = () => {
		return (
			<div
				className={`toolsSidebar ${currentExitTab === 'tab-exit' ? 'hiddenExitCriteria' : ''
					} `}
				style={{ minHeight: toolsSidebarHeight }}
			>
				{
					outputContributionReorder && <>
						<div className="sideBarCard userAddedItem">
							<div className="sideBarCardHeader">
								<img
									className="userImg"
									src={ckEditorCurrentOutputReorderUserImage}
									alt=""
								/>
								<span>{ckEditorCurrentOutputReorderUsername}</span>
								<Icon
									title="Reject Suggestion"
									ariaLabel={`Click to reject the Reorder`}
									role="button"
									iconName="Cancel"
									onClick={() => removeReorderedSuggestions('output')}
									onKeyPress={(e) => {
										if (e.which === 13) {
											removeReorderedSuggestions('output');
										}
									}}
									tabIndex={0}
								/>
								 {pageType.includes(source) &&
								 ckEditorCurrentOutputReorderUsername !== user.profile.firstName + ' '+ user.profile.surname &&
                                 (
                                        <Icon
                                  title="Accept Suggestion"
                                  iconName="Accept"
                                  onClick={() => acceptOutputReorderSuggestion()}
                                  onKeyPress={(e) => {
                                    if (e.which === 13) {
										acceptOutputReorderSuggestion();
                                    }
                                  }}
                                  ariaLabel={'click to accept as suggestion'}
                                  role="button"
                                  tabIndex={0}
                                />
                              
                              )}
								<div className="itemStatus">
									<span>
										Reordered
									</span>
									&nbsp;"Description: Output has been Reordered"
								</div>

							</div>
						</div>

					</>
				}
				{exitCriteriaSuggestions &&
					exitCriteriaWithSuggestions.map((card) => (
						<>
							{JSON.parse(card).criteriaTypeName === 'Output' &&
								(JSON.parse(card).suggestionType === 'none' ? (
									<></>
								) : (
									<div
										className={`sideBarCard ${JSON.parse(card).suggestionType === 'deletion'
											? 'userDeletedToolsAndGuidance'
											: 'userAddedItem'
											}`}
									>
										<div className="sideBarCardHeader">
											<img
												className="userImg"
												src={ckEditorUserMap[JSON.parse(card).authorId][1]}
												alt=""
											/>
											<span className="nonCkEditorAuthor">
												{ckEditorUserMap[JSON.parse(card).authorId][0]}
											</span>

											{JSON.parse(card).authorId === CkEditorCurrentUser ||
												(pageType.includes(source) &&
													JSON.parse(card).authorId !== CkEditorCurrentUser) ? (
												<Icon
													title="Reject Suggestion"
													ariaLabel={`Click to reject ${JSON.parse(card).name
														} as suggestion`}
													role="button"
													iconName="Cancel"
													onClick={() => removeOutputSuggestion(card)}
													onKeyPress={(e) => {
														if (e.which === 13) {
															removeOutputSuggestion(card);
														}
													}}
													tabIndex={0}
												/>
											) : (
												<></>
											)}
											{pageType.includes(source) &&
												JSON.parse(card).authorId !== CkEditorCurrentUser ? (
												<Icon
													title="Accept Suggestion"
													iconName="Accept"
													onClick={() => acceptOutputSuggestion(card)}
													onKeyPress={(e) => {
														if (e.which === 13) {
															acceptOutputSuggestion(card);
														}
													}}
													ariaLabel={`Click to Accept ${JSON.parse(card).name
														} as suggestion`}
													role="button"
													tabIndex={0}
												/>
											) : (
												<></>
											)}
										</div>
										<div className="itemStatus">
											<span>
												{JSON.parse(card).suggestionType === 'insertion'
													? 'Add'
													: JSON.parse(card).suggestionType === 'deletion'
														? 'Remove'
														: 'Edit'}
											</span>
											&nbsp;"
											{JSON.parse(card).name}"
										</div>
									</div>
								))}
						</>
					))}
			</div>
		);
	};


    const getFilteredItems = (tab) => {
        return exitCriteriaWithSuggestions
            .map((item) => JSON.parse(item))
            .filter((item) =>
                tab === "tab-exit" ? item.criteriaTypeName === "Exit Criteria" : item.criteriaTypeName === "Output"
            );
    };



    const handleAddItem = () => {
        if (newItemDescription.trim() === "") return;

        const newItem = {
            id: uniqueIdGenerator(),
            name: newItemDescription,
			description: "",
            criteriaType: "Exit",
            valueType: criteriaType.name === 'Text' ? 1 : 2,
			activityId: null,
		  	complexityId: 3,
            createdDate: new Date().toISOString(),
            modifiedDate: new Date().toISOString(),
            createdBy: CkEditorCurrentUser,
            modifiedBy: CkEditorCurrentUser,
            criteriaTypeID: currentExitTab === "tab-exit" ? 2 : 4,
            criteriaTypeName: currentExitTab === "tab-exit" ? "Exit Criteria" : "Output",
            sequence: getFilteredItems(currentExitTab).length + 1,
            suggestionType: "insertion",
            authorId: CkEditorCurrentUser,
            suggestionId: uniqueIdGenerator(),
            createdAt: new Date().toISOString(),
        };

        setExitCriteriaWithSuggestions((prev) => [...prev, JSON.stringify(newItem)]);
		setExitCriteriaSuggestions((prev) => [...prev, JSON.stringify(newItem)]);
        setNewItemDescription("");
        setIsHideInputBox(false);
    };
	const handleItemChange = (e, index, item) => {
		const value = e.target.value;
	
		setExitCriteriaWithSuggestions((prev) =>
			// prev.map((entry) =>
			// 	JSON.parse(entry).id === item.id
			// 		? JSON.stringify({ 
			// 			...JSON.parse(entry), 
			// 	name: value, 
			// 	suggestionType: "updation",
			// 	authorId: CkEditorCurrentUser,
			// 	createdAt: new Date(),
			// 		})
			// 		: entry
			// )
			prev.map((entry) =>
							JSON.parse(entry).id === item.id
								? JSON.stringify({
									  ...JSON.parse(entry),
									  name: value,
									  suggestionType: "updation",
									  suggestionId: uniqueIdGenerator(),
									  authorId: CkEditorCurrentUser,
									  createdAt: new Date(),
									  valueType: item.valueType, // Preserve valueType from the existing entry
								  })
								: entry
						)
		);
		
		setExitCriteriaSuggestions((prevState) => {
					if (!prevState.some((entry) => JSON.parse(entry).id === item.id)) {
						const newEntry = JSON.stringify({
							...item,
							name: value,
							suggestionType: "updation",
							suggestionId: uniqueIdGenerator(),
							authorId: CkEditorCurrentUser,
							createdAt: new Date(),
							valueType: item.valueType,
						});
			
						return [...prevState, newEntry];
					} else {
						return prevState.map((entry) =>
							JSON.parse(entry).id === item.id
								? JSON.stringify({
									  ...JSON.parse(entry),
									  name: value,
									  suggestionType: "updation",
									  suggestionId: uniqueIdGenerator(),
									  authorId: CkEditorCurrentUser,
									  createdAt: new Date(),
									  valueType: item.valueType,
								  })
								: entry
						);
					}
				});
	};
 

	const handleRemoveButtonClick = (item) => {
		const isExitItem = item.criteriaTypeName === "Exit Criteria";
		const originalList = isExitItem ? exitCriteriaList : outputList;
	
		//  Case 1: If current user created the row & it's not an "updation", remove it
		if (item.createdBy === CkEditorCurrentUser && item.suggestionType !== "updation") {
			setExitCriteriaWithSuggestions((prev) => prev.filter((entry) => JSON.parse(entry).id !== item.id));
			return;
		}
	
		// Find the original item
		let originalItem = originalList.find((entry) => entry.id === item.id) ||
						   exitCriteriaWithSuggestions.find((entry) => JSON.parse(entry).id === item.id);
	
		if (!originalItem) return console.error(`Original item with ID ${item.id} not found.`);
	
		//  Case 2: If user modified an existing row, revert or mark as deletion
		if (item.suggestionType === "updation") {
			setExitCriteriaWithSuggestions((prev) =>
				prev.map((entry) => JSON.parse(entry).id === item.id
					? JSON.stringify(item.authorId === CkEditorCurrentUser 
						? { ...originalItem, suggestionType: "none" }  // 🔄 Revert changes
						: { ...JSON.parse(entry), suggestionType: "deletion", suggestionId: uniqueIdGenerator(), authorId: CkEditorCurrentUser, createdAt: new Date() }) // ❌ Mark deletion
					: entry)
			);
			return;
		}
	
		//  Case 3: If row was not created by current user → Mark as "deletion"
		setExitCriteriaWithSuggestions((prev) =>
			prev.map((entry) => JSON.parse(entry).id === item.id
				? JSON.stringify({ ...JSON.parse(entry), suggestionType: "deletion", suggestionId: uniqueIdGenerator(), authorId: CkEditorCurrentUser, createdAt: new Date() })
				: entry)
		);
	};
	

    // const handleDropdownChange = (tabId, itemId, selectedValue) => {
     
    // };

	const handleDropdownChange = (index, tabId, itemId, newId) => {
		const newValueType = parseInt(newId.id);
		const currentItem = exitCriteriaList[index]?exitCriteriaList[index]:exitCriteriaWithSuggestions[index];
	 
		if (currentItem.valueType === newValueType) {
			return; // If the value is the same, do nothing
		}
	 
		const updatedList = exitCriteriaList.map((item, i) => {
			if (i === index) {
				return { ...item, valueType: newValueType };
			}
			return item;
		});
		setExitCriteriaList(updatedList);
		setExitCriteriaWithSuggestions((prev) =>
			prev.map((entry) =>
				JSON.parse(entry).id === itemId
					? JSON.stringify({
						  ...JSON.parse(entry),
						  valueType: newValueType,
						  suggestionType: "updation",
						  suggestionId: uniqueIdGenerator(),
						  authorId: CkEditorCurrentUser,
						  createdAt: new Date(),
					  })
					: entry
			)
		);
	 
		setExitCriteriaSuggestions((prevState) => {
			const existingEntry = prevState.find((entry) => JSON.parse(entry).id === itemId);
			if (!existingEntry) {
				const newEntry = JSON.stringify({
					id: itemId,
					valueType: newValueType,
					suggestionType: "updation",
					suggestionId: uniqueIdGenerator(),
					authorId: CkEditorCurrentUser,
					createdAt: new Date(),
				});
	 
				return [...prevState, newEntry];
			} else {
				return prevState.map((entry) =>
					JSON.parse(entry).id === itemId
						? JSON.stringify({
							  ...JSON.parse(entry),
							  valueType: newValueType,
							  suggestionType: "updation",
							  suggestionId: uniqueIdGenerator(),
							  authorId: CkEditorCurrentUser,
							  createdAt: new Date(),
						  })
						: entry
				);
			}
		});
	 
		setDropdownValues((prev) => ({
			...prev,
			[`${tabId}-${itemId}`]: newId,
		}));
	};

	const handleExitTabClick = (tabId) => {
		setCurrentExitTab(tabId);
		setCurrentExitTab(tabId); // Prop Update
	  };

    const renderTabContent = (tabId) => {
        const items = getFilteredItems(tabId);
        return (
            <div id={tabId} className={`exit-criteria-tab-content ${currentExitTab === tabId ? "currentExit" : ""}`}>
				<div>
					{items.map((item, index) => (
						<div key={item.id}>
							<div className="addPolygonTopicRelatedInputContainer">
								<div className="polygonInputContainer">
									<div className="row">
										{tabId === "tab-exit" && (
											<div className="px-0">
												<Dropdown
													className="entryEditCriteriadropdown"
													data={dropdownValue}
													value={dropdownValue.find(option => option.id === item.valueType) || dropdownValue[0]}
													setValue={(selectedValue) => handleDropdownChange(index, tabId, item.id, selectedValue)}
													enableDropdown={!disableControls}
													pageType={"Activity"}
													renderFrom={'crowdSourcing'}
												/>
											</div>
										)}
										<div className={`inputBox p-0`}>
											<input
												ref={(el) => (inputRefs.current[index] = el)}
												className={`exitEditCriteriaInput 
													${item.suggestionType === "none" ? "" : 
													item.suggestionType === "insertion" ? "addedCriteria" : 
													item.suggestionType === "updation" ? "updatedCriteria" : 
													"deletedCriteria"}`}
												onChange={(e) => handleItemChange(e, index, item)}
												value={item.name}
												readOnly={disableControls}
												style={disableControls?{cursor: "default"}:{}}
											/>
										</div>
										<div className='d-flex justify-content-center'>
										<div className="addPolygonTopicFieldSave">
											<button
												disabled={disableControls}
												tabIndex={0}
												title="Remove"
												role="button"
												aria-label="Remove"
												className={`${disableControls?'disableIconsCross relatededitContentDelete':'relatededitContentDelete'}`}
												onClick={() => handleRemoveButtonClick(item)}
											></button>
										</div>
										{isHideInputBox && index === items.length - 1 &&
											<div className="addPolygonTopicFieldSave mt-2">
												<button
													disabled={disableControls}
													tabIndex={0}
													title="Add"
													role="button"
													aria-label="Add"
													className={`${disableControls?'disableIconsAdd relatedContentAdd':'relatedContentAdd'}`}
													onClick={() => setIsHideInputBox(false)}
													></button>
											</div>
										}
										</div>
									</div>
								</div>
							</div>
						</div>
					))}
					{!isHideInputBox && (
						<div className="addPolygonTopicRelatedInputContainer">
							<div className="polygonInputContainer">
								<div className="row">
									{tabId === "tab-exit" && (
										<div className="px-0" >
											<Dropdown
												className="entryEditCriteriadropdown"
												data={dropdownValue}
												value={criteriaType}
												setValue={setCriteriaType}
												enableDropdown={!disableControls}
												pageType={"Activity"}
												renderFrom={'crowdSourcing'}
											/>
										</div>
									)}
									<div className={`inputBox p-0`}>
										<input
											value={newItemDescription}
											className="entryEditCriteriaInput"
											onChange={(e) => setNewItemDescription(e.target.value)} // Update value on change
											onBlur={(e) => {
												if (e.relatedTarget?.getAttribute("aria-label") !== "Remove") {handleAddItem()}
											}} 
											placeholder={`Enter new ${tabId === "tab-exit" ? "Exit Criteria" : "Output"}`}
											readOnly={disableControls}
											style={disableControls?{cursor: "default"}:{}}
										/>
									</div>
									<div className='d-flex justify-content-center'>
									{!isHideInputBox && items.length  !== 0 &&
										<div className="addPolygonTopicFieldSave">
											<button
												disabled={disableControls}
												tabIndex={0}
												title="Remove"
												role="button"
												aria-label="Remove"
												className={`${disableControls?'disableIconsCross relatededitContentDelete':'relatededitContentDelete'} ${tabId === "tab-entry" ? "AddEntryBtn" : "AddInputBtn"}`}
												onClick={()=>{
													if (newItemDescription.trim() !== "") {setNewItemDescription("")}
													setIsHideInputBox(true);
												}}
											></button>
										</div> 
									}
										<div className="addPolygonTopicFieldSave">
											<button
											disabled={disableControls}
											tabIndex={0}
											title="Add"
											role="button"
											aria-label="Add"
											className={`${disableControls?'disableIconsAdd relatedContentAdd':'relatedContentAdd'} ${tabId === "tab-entry" ? "AddEntryBtn" : "AddInputBtn"}`}
											oonClick={()=>{
												handleAddItem();
												if(items.length===0) setIsHideInputBox(false);
											}}
											></button>
										</div>
									</div>

								</div>
							</div>
						</div>
					)}
				</div>
            </div>
        );
    };


	useEffect(() => {
		const exitItems = getFilteredItems('tab-exit');
		const outputItems = getFilteredItems('tab-output');
		if (exitItems.length===0)  setIsHideInputBox(exitItems.length > 0);
		if (outputItems.length===0) setIsHideInputBox(outputItems.length > 0);
	  }, [currentExitTab, exitCriteriaWithSuggestions]);
	  

    return (
        <div className="topicDetailsCkEditor entryExitCriTab">
            <div className="criteria-tab-container">
                <ul className="entry-criteria-tabs" role="tablist">
                    <li 
					className={currentExitTab === 'tab-exit' ? 'currentEntry' : ''}
					onClick={() => {
						handleExitTabClick('tab-exit')
						if (getFilteredItems(currentExitTab)?.length !== 0) {
							setIsHideInputBox(true);
						  }
					}}
					>
					Exit Criteria
					</li>
                    <li 
						className={currentExitTab === 'tab-output' ? 'currentEntry' : ''}
						onClick={() => {
							handleExitTabClick('tab-output');
							if (getFilteredItems(currentExitTab)?.length !== 0) { setIsHideInputBox(true); }
						}}
					>
					Output
					</li>
                </ul>
                {renderTabContent("tab-exit")}
                {renderTabContent("tab-output")}
            </div>
			{renderSuggestions()}
			{renderOutputSuggestions()}
        </div>
    );
};

export default ExitCriteriaContribution;
